import React, {useState, useEffect} from 'react';
import { styled } from '@mui/material/styles';
import {useViewport} from '../../../../helpers';
import {useTranslation} from 'react-i18next';
import {
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { Typography } from '@mui/material';
import clsx from 'clsx';

const PREFIX = 'Price';

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  buttonsContainer: `${PREFIX}-buttonsContainer`,
  marginTop: `${PREFIX}-marginTop`,
  divider: `${PREFIX}-divider`,
  modifySelect: `${PREFIX}-modifySelect`,
  selectMenuStyle: `${PREFIX}-selectMenuStyle`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: '100%',
    textAlign: 'center',
    paddingTop: '1rem',
  },

  [`& .${classes.paddingRoot}`]: {
    padding: '1rem',
  },

  [`& .${classes.title}`]: {
    marginBottom: '0.5rem !important',
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: '1.5rem !important'
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    margin: '0 auto'
  },

  [`& .${classes.buttonContainer}`]: {
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.up('sm')]: {
      width: '90%',
    },
  },

  [`& .${classes.actionButton}`]: {
    float: 'right',
  },

  [`& .${classes.buttonsContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },

  [`& .${classes.marginTop}`]: {
    marginTop: '1rem'
  },

  [`& .${classes.divider}`]: {
    // marginTop: '2rem',
    // marginBottom: '2rem',
  },

  [`& .${classes.modifySelect}`]: {
    width: '100%',
  },

  [`& .${classes.selectMenuStyle}`]: {
    backgroundColor: '#424242'
  }
}));

const Price = (props) => {

  const {width} = useViewport();
  const {t, i18n} = useTranslation();
  const [isFree, setIsFree] = useState(null);

  useEffect(() => {
    if (isFree === null || (isFree === false && props.exparience.packageId.length > 0 && props.exparience.offeringId.length > 0))
      props.setIsValid(false);
    else
      props.setIsValid(true);
  }, [isFree])

  if (props.currentStep >= 6) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>{t('exparienceCreateForm.priceTitle')}</Typography>
          <Typography variant="body2"className={classes.subTitle}>{t('exparienceCreateForm.priceSubTitle')}</Typography>
          <div className={classes.contentContainer}>
            <div className={classes.buttonsContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={e => setIsFree(false)}
                style={{
                  border: isFree === false && '1px solid white',
                  opacity: isFree && '0.5',
                }}
              >
                {t('exparienceCreateForm.yes')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{
                  border: isFree && '1px solid white',
                  opacity: isFree === false && '0.5',
                }}
                onClick={e => {
                  setIsFree(true);
                  props.handleChangeField('multiple', {packageId: '', offeringId: ''})
                  props.handleNextStep(7);
                }}
              >
                {t('exparienceCreateForm.no')}
              </Button>
            </div>
            {isFree === false &&
              <div className={classes.marginTop}>
                <div>
                  <FormControl className={classes.modifySelect}>
                    <InputLabel id="package-select-outlined-label">{t('exparienceCreateForm.selectOffer')}</InputLabel>
                    <Select
                      labelId="package-select-outlined-label"
                      id="package-select-outlined"
                      className={classes.selectStyle}
                      value={props.exparience.packageId}
                      MenuProps={{ classes: { paper: classes.selectMenuStyle }}}
                      onChange={e => {
                        const tmp = props.offerings.filter(offer => offer.id === e.target.value);
                        if (tmp.length > 0) {
                          props.handleChangeField('multiple', {packageId: e.target.value, offeringId: tmp[0].offeringId})
                        } else {
                          props.handleChangeField('multiple', {packageId: '', offeringId: ''})
                        }
                      }}
                      label="Package price"
                    >
                      <MenuItem key="none" value="">{t('myExpariences.noOffer')}</MenuItem>
                      {props.offerings.map(offer => (
                        <MenuItem key={offer.id} value={offer.id}>{`${offer.price}€ - ${offer.duration}`}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            }
          </div>
          {props.currentStep === 6 && isFree === false &&
            <div className={clsx(classes.buttonContainer, classes.marginTop)}>
              <Button
                variant="contained"
                color="primary"
                disabled={props.exparience.packageId.length === 0 || props.exparience.offeringId.length === 0}
                onClick={e => props.handleNextStep(7)}
                className={classes.actionButton}
              >
                {t('exparienceCreateForm.continueButton')}
              </Button>
            </div>
          }
        </div>
        <Divider light className={classes.divider}/>
      </Root>
    );
  } else {
    return null;
  }
}

export default Price;